import { combineReducers } from 'redux';
import userCommunities from './userCommunities';
import communityPosts from './communityPosts';
import membersList from './membersList';
import moderatorsList from './moderatorsList';
import communityMembers from './communityMembers';
import communityModerators from './communityModerators';
import postsList from './postsList';
import postDetails from './postDetails';
import createPost from './createPost';
import postsCreated from './postsCreated';
import editPost from './editPost';
import newPostForm from './newPostForm';
import currentCommunity from './currentCommunity';
import postComment from './postComment';
import commentsList from './commentsList';
import deletePost from './deletePost';
import likePost from './likePost';
import dislikePost from './dislikePost';
import reqDiscoverCommunities from './reqDiscoverCommunities';
import currentCommunityInfo from './currentCommunityInfo';
import reqJoinCommunity from './reqJoinCommunity';
import communitiesJoinRequests from './communitiesJoinRequests';
import acceptJoinRequest from './acceptJoinRequest';
import declineJoinRequest from './declineJoinRequest';
import getUserProfile from './getUserProfile';
import communityPreview from './communityPreview';
import communityPostsPreview from './communityPostsPreview';
import joinPopup from './joinPopup';
import reqMemberInvitation from './reqMemberInvitation';
import notificationCounters from './notificationCounters';
import removeNotificationsCounters from './removeNotificationsCounters';
import usersJoinRequests from './usersJoinRequests';
import currentCommunityScrollStatus from './currentCommunityScrollStatus';
import communityImageUpdate from './communityImageUpdate';
import communityImageRemove from './communityImageRemove';
import leaveCommunity from './leaveCommunity';
import removeUserCommunity from './removeUserCommunity';
import communityInfoUpdate from './communityInfoUpdate';
import invitationUserSearch from './invitationUserSearch';
import invitationUserToCommunity from './invitationUserToCommunity';
import acceptInvitation from './acceptInvitation';
import declineInvitation from './declineInvitation';
import activities from './activities';

export default combineReducers({
  removeUserCommunity,
  leaveCommunity,
  userCommunities,
  communityPosts,
  postsList,
  membersList,
  moderatorsList,
  communityMembers,
  communityModerators,
  postDetails,
  createPost,
  postsCreated,
  editPost,
  newPostForm,
  currentCommunity,
  postComment,
  commentsList,
  deletePost,
  likePost,
  dislikePost,
  reqDiscoverCommunities,
  currentCommunityInfo,
  reqJoinCommunity,
  communitiesJoinRequests,
  acceptJoinRequest,
  declineJoinRequest,
  getUserProfile,
  communityPreview,
  communityPostsPreview,
  joinPopup,
  reqMemberInvitation,
  notificationCounters,
  removeNotificationsCounters,
  usersJoinRequests,
  currentCommunityScrollStatus,
  communityImageUpdate,
  communityImageRemove,
  communityInfoUpdate,
  invitationUserSearch,
  invitationUserToCommunity,
  acceptInvitation,
  declineInvitation,
  activities,
});



// WEBPACK FOOTER //
// ./src/redux/communities/index.js